import './modernizr-lib';

export default function() {
    if (!Modernizr.objectfit) {
        $('.js-has-object-fit-image').each((index, element) => {
            let $container = $(element),
                imgUrl = $container.find('img').prop('src');

            if (imgUrl) {
                $container
                    .css('backgroundImage', 'url(' + imgUrl + ')')
                    .addClass('modernizr_object-fit-container');
            }
        });
    }
}